/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { LoadingSpinner, Header } from '@blend/enterprise-components';
import { css, StyleSheet } from 'aphrodite';

export namespace Status {
  export interface Props {
    isLoading: boolean;
    isEmpty: boolean;
    emptyMessage: string;
  }
}

export const styles = StyleSheet.create({
  centeredContainer: {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    width: '100%',
    padding: '12px',
  },
});

export const Status: React.FC<Status.Props> = ({ isLoading, isEmpty, emptyMessage }) => {
  if (isLoading) {
    return (
      <div className={css(styles.centeredContainer)}>
        <LoadingSpinner size="lg" theme="secondary" />
      </div>
    );
  }
  if (isEmpty) {
    return (
      <div className={css(styles.centeredContainer)}>
        <Header size={2}>{emptyMessage}</Header>
      </div>
    );
  }
  return null;
};
